import React, { useState } from "react";  
import "./SignIn.css";  
import { useNavigate } from "react-router-dom";  
import logo from "../images/Metso-logo.png";  
import backgroundVideo from '../Videos/mining video.mp4';  
  
export function SignIn() {  
  const [username, setUsername] = useState('');  
  const [password, setPassword] = useState('');  
  const [errorMessage, setErrorMessage] = useState('');  
  const navigate = useNavigate();  
  async function SubmitAction() {  
    if (!username || !password) {  
      setErrorMessage('Please enter both username and password');  
      return;  
    }  
    try {  
      console.log("Entering");      
      const response = await fetch('/usrpwd', {  
        method: 'POST',  
        headers: {  
          'Content-Type': 'application/json'  
        },  
        body: JSON.stringify({ username, password })  
      });  
  
      const data = await response.json();  
  
      if (response.ok) {  
        navigate(data.redirectUrl); 
      } else {  
        setErrorMessage(data.error);  
      }  
    } catch (error) {  
      setErrorMessage('Error during login');
      console.log(setErrorMessage,"dsaf");
    }  
  }  
  
  return (  
    <section className="signup-page">  
      <video className="background-video" autoPlay loop muted>  
        <source src={backgroundVideo} type="video/mp4" />  
      </video>  
      <div className="gradient-overlay"></div>  
      <div className="logo-container">  
        <img src={logo} alt="Logo" className="logo" />  
      </div>  
      <div className="form-container1">  
        <h1>Sign In to Your Account</h1>  
        {errorMessage && <p className="error-message">{errorMessage}</p>}  
        <div className="input-container">  
          <label htmlFor="username">Username</label>  
          <input  
            type="text"  
            id="username"  
            name="username"  
            value={username}  
            onChange={(e) => setUsername(e.target.value)}  
          />  
        </div>  
        <div className="input-container">  
          <label htmlFor="password">Password</label>  
          <input  
            type="password"  
            id="password"  
            name="password"  
            value={password}  
            onChange={(e) => setPassword(e.target.value)}  
          />  
        </div>  
        <button className="signup-button" onClick={SubmitAction}>  
          Sign In  
        </button>  
      </div>  
    </section>  
  );  
}  



// This is for SSO

// import React, { useEffect, useState } from "react";  
// import "./SignIn.css";  
// import { useNavigate } from "react-router-dom";  
// import logo from "../images/Metso-logo.png";  
// // import { PublicClientApplication } from "@azure/msal-browser";  
// const backgroundVideo = require('../Videos/mining video.mp4');  


// // const clientID = ``
// // const tenantId = ``
  
// // const msalConfig = {  
// //   auth: {  
// //     clientId: `${clientID}`,  
// //     authority: `https://login.microsoftonline.com/${tenantId}`,   
// //     redirectUri: "http://localhost:3000/broadcastmessage"  
// //   }  
// // };  
  
// // const msalInstance = new PublicClientApplication(msalConfig);  
  
// export function SignIn() {  
//   const navigate = useNavigate();  
//   // const [isInitialized, setIsInitialized] = useState(false);  
  
//   // useEffect(() => {  
//   //   async function initializeMsal() {  
//   //     try {  
//   //       await msalInstance.initialize();  
//   //       setIsInitialized(true);  
//   //     } catch (error) {  
//   //       console.log("MSAL initialization error", error);  
//   //     }  
//   //   }  
//   //   initializeMsal();  
//   // }, []);  
  
//   async function SubmitAction() {  
//   window.location.href = '/auth/login'

//     // if (!isInitialized) {  
//     //   console.log("MSAL is not initialized");  
//     //   return;  
//     // }  
  
//     // try {  
//     //   const loginResponse = await msalInstance.loginPopup({  
//     //     scopes: ["User.Read"],  // API Permission name (Check the api permission from the app registration)
//     //   });  
//     //   console.log("Login Successful", loginResponse);  
//     //   msalInstance.loginRedirect({
//     //     scopes: ["User.Read"],
//     //     prompt:'create'
//     //   })
//     // } catch (Err) {  
//     //   console.log("Error", Err);  
//     // }  
//   }  
  
//   return (  
//     <section className="signup-page">  
//       <video className="background-video" autoPlay loop muted>  
//         <source src={backgroundVideo} type="video/mp4" />  
//       </video>  
//       <div className="gradient-overlay"></div>  
//       <div className="logo-container">  
//         <img src={logo} alt="Logo" className="logo" />  
//       </div>  
//       <div className="form-container1">  
//         <h1>Access Your Future with Metso</h1>  
//         <p>Get Started with One Click</p>  
//         <button className="signup-button" onClick={SubmitAction} >  
//           Signup  
//         </button>  
//       </div>  
//     </section>  
//   );  
// }  